export enum ActionTypes {
  GetTestingCreditsSubscription = 'getTestingCreditsSubscription',
  GetTestingCreditsSubscriptionSuccess = 'getTestingCreditsSubscription.success',
  GetTestingCreditsSubscriptionFailure = 'getTestingCreditsSubscription.failure',

  UpdateTestingCreditSubscription = 'updateTestingCreditSubscription.request',
  UpdateTestingCreditSubscriptionSuccess = 'updateTestingCreditSubscription.success',
  UpdateTestingCreditSubscriptionFailure = 'updateTestingCreditSubscription.failure',
}
